import React, { FC } from 'react';

import { FilterPanelMain } from '@src/common/FilterPanelPage/FilterPanelMain';
import { FilterPanel } from '@src/common/FilterPanelPage/FilterPanel';
import { EventSearchFilterPanel } from './components/EventSearchFilterPanel';
import { EventSearchResults } from './components/EventSearchResults';
import { ResultsContent } from '../../../common/FilterPanelPage/results/ResultsContent';
import { EventSearchResultsChartBarTooltip } from './components/resultsComponents/EventSearchResultsChartBarTooltip';

export const EventSearchPage: FC = () => {
  return (
    <FilterPanelMain>
      <FilterPanel>
        <EventSearchFilterPanel />
      </FilterPanel>
      <ResultsContent>
        <EventSearchResults />
      </ResultsContent>
      <EventSearchResultsChartBarTooltip />
    </FilterPanelMain>
  );
};
